<template>
  <div>
    <zj-layout-container>
      <zj-layout-header>
        <div class="listtitle">商户提现申请</div>
        <el-form
          class="zj-search-form"
          ref="form"
          :model="form"
          :label-width="labelWidth"
        >
          <el-form-item label="查询时间起：">
            <el-date-picker
              v-model="CreateTime_Start"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              default-time="00:00:00"
            ></el-date-picker>
          </el-form-item>
          <el-form-item label="至：">
            <el-date-picker
              v-model="CreateTime_End"
              type="datetime"
              placeholder="选择日期时间"
              format="yyyy-MM-dd HH:mm:ss"
              default-time="23:59:59"
            ></el-date-picker>
          </el-form-item>
          <el-form-item
            label="商户"
            prop="CurrentBusinessCode"
          >
            <el-select
              filterable
              placeholder="请选择"
              v-model="CurrentBusinessCode"
              :disabled="BusinessCodeDisabled"
              clearable
            >
              <el-option
                v-for="item in Businesses"
                :key="item.BusinessCode"
                :label="item.BusinessName"
                :value="item.BusinessCode"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item
            label="审核状态"
            prop="Status"
          >
            <el-select
              filterable
              placeholder="请选择"
              v-model="CurrentStatus"
              clearable
            >
              <el-option
                v-for="item in Statuses"
                :key="item.Status"
                :label="item.StatusStr"
                :value="item.Status"
              >
              </el-option>
            </el-select>
          </el-form-item>
          <el-form-item class="right">
            <el-button @click="onQueryBalance">查询</el-button>
            <el-button
              v-if="isPassed=='1'"
              @click="onOutPayment"
            >申请提现</el-button>
          </el-form-item>
        </el-form>
        <el-divider></el-divider>
      </zj-layout-header>
      <zj-layout-main>
        <div class="zj-layout-main-content bgcolor scrollable">
          <div class="zj-table-container">
            <el-table
              :data="tableData"
              ref="multipleTable"
              @selection-change="selectionChange"
              border
              style="width: 100%"
              fixed
            >
              <el-table-column
                prop="SubMerId"
                label="商户编号"
              ></el-table-column>
              <el-table-column
                prop="SubMerName"
                label="商户名称"
              ></el-table-column>
              <el-table-column
                prop="Account"
                label="收款账号"
              ></el-table-column>
              <el-table-column
                prop="AccountName"
                label="收款账户名称"
              ></el-table-column>
              <el-table-column
                prop="TrxAmount"
                label="交易金额"
              >
                <template slot-scope="scope">
                  {{scope.row.PaySign}}{{scope.row.TrxAmount}}
                </template>
              </el-table-column>
              <el-table-column
                prop="MainPaySeparate"
                label="主商户分账金额"
              >
                <template slot-scope="scope">
                  {{scope.row.PaySign}}{{scope.row.MainPaySeparate}}
                </template>
              </el-table-column>
              <el-table-column
                prop="PaySeparate"
                label="二级商户分账金额"
              >
                <template slot-scope="scope">
                  {{scope.row.PaySign}}{{scope.row.PaySeparate}}
                </template>
              </el-table-column>
              <el-table-column
                prop="CreateTime"
                label="时间"
              ></el-table-column>
              <el-table-column
                prop="StatusStr"
                label="审核状态"
              ></el-table-column>
              <el-table-column
                fixed="right"
                label="操作"
                width="120"
                align="center"
              >
                <template slot-scope="scope">
                  <el-button
                    @click="queryClick(scope.$index, scope.row)"
                    type="text"
                    size="small"
                  >查看</el-button>
                </template>
              </el-table-column>
            </el-table>
          </div>
        </div>
      </zj-layout-main>
      <zj-layout-footer>
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="handleCurrentChange"
          :current-page="currentPage"
          :page-sizes="[5, 10, 20, 50, 100]"
          :page-size="pageSize"
          layout="total, sizes, prev, pager, next, jumper"
          background
          :total="total"
        ></el-pagination>
      </zj-layout-footer>
    </zj-layout-container>
    <ZjDialog
      :title="dilaogconfig.title"
      :dialogFormVisible="dilaogconfig.dialogFormVisible"
      :width="dilaogconfig.width"
      :height="dilaogconfig.height"
      @clickCancel="handleDialogCancel"
    >
      <BusinessApplyInfoPage
        @clickOk="handleDialogOk"
        @clickCancel="handleDialogCancel"
        :BusinessCode="CurrentBusinessCode"
        :AccountName="AccountName"
        :SubMerchantAccNo="SubMerchantAccNo"
        :RecBankNo="RecBankNo"
        :IsOutPay="IsOutPay"
      ></BusinessApplyInfoPage>
    </ZjDialog>
  </div>
</template>

<script>
import WebApis from "../../../apis";
import utils from "../../../../../../utils";
import { showLoading, hideLoading } from "../../../../../../loading";
import BusinessApplyInfoPage from "./BusinessApplyInfo.vue";
import ZJApp from "../../../../../app";

export default {
  name: "BusinessApplyPage",
  controller: "UI",
  action: "BusinessApply",
  data() {
    return {
      currentPage: 1,
      pageSize: 10,
      total: 0,
      tableData: [],
      CreateTime_Start: this.get_Day(0) + " 00:00:00",
      CreateTime_End: this.get_Day(0) + " 23:59:59",
      tableHeight: window.innerHeight - 440,
      dilaogconfig: {
        title: "商户提现申请",
        dialogFormVisible: false,
        width: "900px",
      },
      multipleSelection: [],
      IsOutPay: false,
      CurrentBusinessCode: "",
      AccountName: "",
      SubMerchantAccNo: "",
      RecBankNo: "",
      isPassed: "1",
      Businesses: [],
      BusinessCodeDisabled: false,
      CurrentStatus: 0,
      Statuses: [
        {
          Status: 0,
          StatusStr: "全部",
        },
        {
          Status: 1,
          StatusStr: "审核通过",
        },
        {
          Status: 2,
          StatusStr: "审核不通过",
        },
      ],
    };
  },
  components: {
    BusinessApplyInfoPage,
  },
  props: {
    width: {
      type: String,
      default: "200px",
    },
  },
  created: function () {
    let user = this.user;

    if (user.LoginName != "admin") {
      this.CurrentBusinessCode = user.LoginName;
      this.BusinessCodeDisabled = true;
    } else {
      this.CurrentBusinessCode = null;
      this.BusinessCodeDisabled = false;
    }

    return utils
      .waitAll([
        () => this.GetBusiness(),
        () => this.getBusinessByBusinessCode(),
      ])
      .then(() => {
        this.init();
      });
  },
  mounted: function () {
    const that = this;
    window.onresize = () => {
      return (() => {
        that.tableHeight = window.innerHeight - 440;
      })();
    };
  },
  computed: {},
  methods: {
    init() {
      return this.GetSubMerAccOutPaymentRecord();
    },
    GetBusiness() {
      return new WebApis.BusinessApi()
        .FindAll()
        .then((r) => {
          console.log(r);
          r = r.data.Data;
          this.Businesses = r;
        })
        .catch((e) => {
          console.log(e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取商户数据异常！" + e.RspMsg
              : "获取商户数据异常！",
            type: "error",
          });
        });
    },
    GetBusinessByUser(user) {
      var result = "";
      this.Businesses.forEach(function (item) {
        if (item.BusinessCode == user.LoginName) {
          result = user.LoginName;
          return;
        }
      });
      return result;
    },
    getBusinessByBusinessCode() {
      let BusinessSearch = {
        BusinessCode:
          this.CurrentBusinessCode != "" ? this.CurrentBusinessCode : null,
      };

      return new WebApis.BusinessApi()
        .GetItemByBusinessCode(BusinessSearch)
        .then((res) => {
          this.BusinessInfo = res.data.Data;
          this.AccountName = this.BusinessInfo.AccountName;
          this.SubMerchantAccNo = this.BusinessInfo.Account;
          this.RecBankNo = this.BusinessInfo.BankNo;
          this.isPassed = this.BusinessInfo.isPassed;

          if (this.BusinessInfo.IsMain == "1") {
            this.CurrentBusinessCode = null;
            this.BusinessCodeDisabled = false;

            this.Business_Code = "";
            this.BusinessCodeDisabled = false;
          }
        });
    },
    GetSubMerAccOutPaymentRecord() {
      showLoading(".zj-table-container");

      let BusinessOrderSearch = {
        PageSize: this.pageSize,
        PageIndex: this.currentPage,
        SubMerId:this.CurrentBusinessCode != "" ? this.CurrentBusinessCode : null,
        Status: this.CurrentStatus != 0 ? this.CurrentStatus : null,
        OrderNo: this.Order_Code != "" ? this.Order_Code : null,
        BeginDate: new Date(this.CreateTime_Start),
        EndDate: new Date(this.CreateTime_End),
        TotalCount: 0,
      };

      console.log(BusinessOrderSearch);
      return new WebApis.BusinessOutPaymentApi()
        .GetPageContentByConditions(BusinessOrderSearch)
        .then((r) => {
          r = r.data.Data;
          this.tableData = r.PageContents;
          this.total = r.BaseSearch.TotalCount;
          hideLoading();
        })
        .catch((e) => {
          console.log("获取交易记录异常", e);
          this.$message({
            showClose: true,
            message: e.RspMsg
              ? "获取商户提现数据异常！" + e.RspMsg
              : "获取商户提现数据异常！",
            type: "error",
          });
          hideLoading();
        });
    }, // 点击查询按钮
    onSearch() {
      this.currentPage = 1;
      this.GetSubMerAccOutPaymentRecord();
    },
    clearsearch() {
      this.Order_Code = "";
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.GetSubMerAccOutPaymentRecord();
    },
    handleCurrentChange(val) {
      this.currentPage = val;
      this.GetSubMerAccOutPaymentRecord();
    },
    formatTime(row, column) {
      const date = new Date(row[column.property]);
      return (
        date.getFullYear() +
        "年" +
        date.getMonth() +
        "月" +
        date.getDate() +
        "日"
      );
    },
    formatDate(dateTime) {
      const date = new Date(dateTime);
      return (
        date.getFullYear() + "-" + (date.getMonth() + 1) + "-" + date.getDate()
      );
    },
    onQueryBalance() {
      this.GetSubMerAccOutPaymentRecord();
    },
    onDownLoad(results) {
      const tHeader = [
        "商户编号",
        "商户名称",
        "收款账号",
        "收款账户名称",
        "交易金额",
        "主账户分账金额",
        "二级账户分账金额",
        "提现状态",
        "商户订单号",
        "时间",
        "操作",
      ];

      var Exportlist = [];

      if (results.length > 0) {
        results.forEach((item) => {
          var obj = [];
          obj.push(item.SubMerId);
          obj.push(item.SubMerName);
          obj.push(item.Extends1);
          obj.push(item.Extends2);
          obj.push(item.Account);
          obj.push(item.AccountName);
          obj.push(item.RecBank);
          if (item.PaySign != null && item.PaySign == "-") {
            item.TrxAmount = 0 - item.TrxAmount;
            item.MainPaySeparate = 0 - item.MainPaySeparate;
            item.PaySeparate = 0 - item.PaySeparate;
          }
          obj.push(item.TrxAmount);
          obj.push(item.MainPaySeparate);
          obj.push(item.PaySeparate);
          obj.push(this.GetStatusStr(item.Status));
          obj.push(item.OrderNo);
          obj.push(item.ThirdPayOrderNo);
          obj.push(item.CreateTime);

          Exportlist.push(obj);
        });
      }

      ZJApp.ZJUtils.Export2Excel.export_json_to_excel(
        tHeader,
        Exportlist,
        "商户管理" + this.get_Day(0)
      );
    },
    GetStatusStr(Status) {
      var StatusStr = "";
      switch (Status) {
        case 1:
          StatusStr = "审核通过";
          break;
        case 2:
          StatusStr = "审核不通过";
          break;
      }
      return StatusStr;
    },
    handleDialogOk() {
      this.dilaogconfig.dialogFormVisible = false;
      this.GetSubMerAccOutPaymentRecord();
    },
    handleDialogCancel() {
      this.dilaogconfig.dialogFormVisible = false;
    },
    onOutPayment() {
      this.IsOutPay = true;
      this.isEdit = true;
      this.dilaogconfig.title = "商户余额";
      this.dilaogconfig.dialogFormVisible = true;
    },
    get_Day(day) {
      let today = new Date();
      let targetday_milliseconds = today.getTime() + 1000 * 60 * 60 * 24 * day;
      today.setTime(targetday_milliseconds);
      let tYear = today.getFullYear();
      let tMonth = today.getMonth();
      let tDate = today.getDate();
      tMonth = this.doHandleMonth(tMonth + 1);
      tDate = this.doHandleMonth(tDate);
      //let timevalue= new Date(tYear + "-" + tMonth + "-" + tDate);
      let timevalue = tYear + "-" + tMonth + "-" + tDate;
      return timevalue;
    },
    doHandleMonth(month) {
      var m = month;
      if (month.toString().length == 1) {
        m = "0" + month;
      }
      return m;
    },
    queryClick(index, row) {
      this.SelectedApplyId = row.ApplyId;
      this.isEdit = false;
      this.dilaogconfig.title = "查看提现申请";
      this.dilaogconfig.dialogFormVisible = true;
    },
  },
};
</script>
